import { client as clientRoutes } from 'config/routes'

export const GOUSTO_ANYTIME_INTENTS = {
  startOneOffOrder: 'start_one_off_order',
  reactivateSubscription: 'reactivate_subscription',
} as const

export const RESUBSCRIBE_URL = `${clientRoutes.mySubscription}?view=resubscribe`
